import { useSouhlAdminQuery } from "@/provider/apollo/Apollo"
import { graphql } from "@/souhl_admin/gql/__generated__"

const query = graphql(/* GraphQL */ `
	query getCancelTypeTexts {
		cancelTypeTexts {
			cancelType
			text
		}
	}
`)

export const useCancelTypeTexts = () => {
	const { data } = useSouhlAdminQuery(query, {
		fetchPolicy: "cache-first",
	})

	const getCancelTypeLabel = (cancelType: string) =>
		data?.cancelTypeTexts?.find((text) => text.cancelType === cancelType)
			?.text || ""

	return {
		cancelTypeTexts: data?.cancelTypeTexts ?? [],
		getCancelTypeLabel,
	}
}
